import Vue from 'vue';

window.axios = require('axios');

Vue.component('latest-roles', require('./LatestRoles.vue'));

const app = new Vue({
    el: '#latest-roles'
});


// WEBPACK FOOTER //
// ./resources/assets/js/careers/latest-roles/latest-roles.js